

export function bloquearCertidao(parm){
  return new Promise(function (resolve, reject) {
    
    window.$http.post(`/eventocertidoes/bloqueio`, JSON.stringify(parm)).then((res) => {
      resolve(res);
    })

  })
}

export function desbloquearCertidao(parm){
  return new Promise(function (resolve, reject) {
    
    window.$http.post(`/eventocertidoes/desbloqueio`, JSON.stringify(parm)).then((res) => {
      resolve(res);
    })

  })
}